import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/PrimeNg.module';
import { FileUploadModule } from 'ng2-file-upload';
import { FirmasMainComponent } from './firmas-main/firmas-main.component';
import { ListarFirmasComponent } from './listar-firmas/listar-firmas.component';
import { AgregarFirmasComponent } from './agregar-firmas/agregar-firmas.component';
import { EditarFirmasComponent } from './editar-firmas/editar-firmas.component';


@NgModule({
  declarations: [
    FirmasMainComponent,
    ListarFirmasComponent,
    AgregarFirmasComponent,
    EditarFirmasComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    PrimeNgModule,
    FileUploadModule,
  ]
})
export class FirmasModule { }
